import React from 'react';
import { Text } from '@servicetitan/design-system';
import { SignatureDocument } from 'src/signature/stores/signature.store';
import { DocumentListItem } from '../document-list-item/document-list-item';
import { DocumentListEmptyMessage } from '../document-list-empty-message/document-list-empty-message';
import {
    isFormSignature,
    isInvoiceSignature,
    isProjectSignature,
    getDocumentId,
} from 'src/signature/util/document-utils';
import { RouteComponentProps, withRouter } from 'react-router';
import { RouteParams } from '../signature-routes';

interface DocumentListProps extends RouteComponentProps<RouteParams> {
    documents: SignatureDocument[];
}

class DocumentListUnwrapped extends React.Component<DocumentListProps> {
    onClickItem = (document: SignatureDocument) => {
        const { history, match } = this.props;
        const { visitActionId } = match.params;

        if (isFormSignature(document)) {
            history.push(`/signatures/${visitActionId}/form-signature/${document.submittingId}`);
        }

        if (isInvoiceSignature(document)) {
            if (document.disclaimers.length && document.signedOn == null) {
                history.push(
                    `/signatures/${visitActionId}/invoice-signature/${document.invoiceId}/${document.signatureType}/0`
                );
            } else {
                history.push(
                    `/signatures/${visitActionId}/invoice-signature/${document.invoiceId}/${document.signatureType}`
                );
            }
        }

        if (isProjectSignature(document)) {
            if (document.disclaimers.length && document.signedOn == null) {
                history.push(
                    `/signatures/${visitActionId}/project-signature/${document.projectId}/${document.signatureType}/0`
                );
            } else {
                history.push(
                    `/signatures/${visitActionId}/project-signature/${document.projectId}/${document.signatureType}`
                );
            }
        }
    };

    getUsignedDocuments = () =>
        this.props.documents
            .filter((document: SignatureDocument) => !document.signedOn)
            .sort(this.sortDoc('requestedOn'));

    getSignedDocuments = () =>
        this.props.documents
            .filter((document: SignatureDocument) => document.signedOn)
            .sort(this.sortDoc('signedOn'));

    sortDoc = (sortBy: string, direction?: 'asc' | 'desc') => (a: any, b: any) => {
        const dir = direction === 'desc' ? 1 : -1;
        const firstItem = a[sortBy];
        const secondItem = b[sortBy];

        if (firstItem > secondItem) return 1 * dir;
        if (firstItem < secondItem) return -1 * dir;

        return 0;
    };

    render() {
        const unsignedDocuments = this.getUsignedDocuments();
        const completedDocuments = this.getSignedDocuments();

        return (
            <React.Fragment>
                <Text el="span" size="4" bold className="m-t-2">
                    Unsigned Documents
                </Text>
                <Text el="span" size="1" className="m-b-2">
                    Select a document to review and sign it.
                </Text>
                {unsignedDocuments.length ? (
                    unsignedDocuments.map((document: SignatureDocument, index) => (
                        <DocumentListItem
                            key={getDocumentId(document) || index}
                            item={document}
                            onClick={this.onClickItem}
                        />
                    ))
                ) : (
                    <DocumentListEmptyMessage />
                )}

                {!!completedDocuments.length && (
                    <React.Fragment>
                        <Text el="span" size="4" bold className="m-t-2">
                            Signed & Completed
                        </Text>
                        <Text el="span" size="1" className="m-b-2">
                            You have signed these documents, a copy of each will be emailed to you
                            when the job is done.
                        </Text>
                        {completedDocuments.map((document: SignatureDocument, index) => (
                            <DocumentListItem
                                key={getDocumentId(document) || index}
                                item={document}
                                onClick={this.onClickItem}
                            />
                        ))}
                    </React.Fragment>
                )}
            </React.Fragment>
        );
    }
}

export const DocumentList = withRouter(DocumentListUnwrapped);
